import { render } from "./page.vue?vue&type=template&id=56ef6e3a"
import script from "./page.vue?vue&type=script&lang=js"
export * from "./page.vue?vue&type=script&lang=js"
script.render = render

export default script